import { RefundProcessStep } from 'src/app/models/RefundProcessStep';

export class Header {
    code?: number;
    message?: string;
    transactionID?: string;
    channel?: string;
    refundProcessStep?: RefundProcessStep;
    processCount?: number;
}
